const features = {
  'features-breadcrumbs-daily': 'Daily',
  'features-breadcrumbs-editors-choice': 'Editor\'s choice',
  'features-breadcrumbs-external-promo': 'External promo',
  'features-table-featured-column': 'Show in featured',
  'features-create-title': 'Create data',
  'features-update-title': 'Edit data',
  'features-form-collapse-title-targets': 'Targets',
  'features-form-image-id-label': 'Image ID',
  'features-form-show-featured-label': 'Show in featured',
  'features-delete-notification': 'Unable to delete, current data is already published',
  'features-utc': 'UTC+0',
  'features-title-info': 'In case when this field is empty it will be filled automatically',
  'features-title-use-automatic-generation-info': 'Title generates automatically',
  'features-show-in-features-info': 'Display feature in app "features section" (Slider at the top of the screen)',
  'features-details-unpublish': 'Unpublish from HC',
  'features-edit-images-to-attach': 'Images ready for use',
  'features-edit-images-to-attach-confirm-message': 'Are you sure you want to use this image? All unsaved changes will be removed.',
  'features-edit-images-to-attach-success': 'Image attached successfully',
  'features-edit-images-to-attach-failed': 'Image attach failed',
  'features-unpublish-failed': 'Failed to unpublish',
  'features-edit-publish-to-hc': 'Publish changes to HappyColor',
  'features-not-featured-tag': 'Not in featured',
  'features-priority-update-past-disabled': 'Changing the order data for past dates is not permitted',
  'features-priority-update-no-order-changed': 'Order is not changed',
  'features-disabled-template-text-error': 'Current template is inactive. To enable publishing please enable template status first.',
  'features-publish-notification-note': 'Publish is not allowed in case when there is no any attached images.',
};

export default features;
